import { UserActionsTypes, SET_USERDATA } from "types/actions/UserData.actions";

const initState = { userData: {} };

export default function authReducer(
  state = initState,
  action: UserActionsTypes
) {
  switch (action.type) {
    case SET_USERDATA:
      return {
        ...state,
        userData: action.userData,
      };
    default:
      return state;
  }
}
